import { pageStoreBuilder } from '@/main/store/pages/page/builder';

import { CRUMB_LABEL_KEY, NAME } from '../constants';

export const store = pageStoreBuilder({
	name: NAME,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
});
